import { Box, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';

export interface WarningBoxProps {
  text: string;
}

function WarningBox({ text }: WarningBoxProps) {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: '6px',
        background: '#dddfe4',
        padding: '20px 24px',
      }}
    >
      <WarningIcon
        sx={{
          color: '#525f81',
        }}
      />
      <Typography color="#525F81" ml="20px" variant="body2" fontSize="16px">
        {t(text)}
      </Typography>
    </Box>
  );
}

export default WarningBox;
